import { LoginForm } from '@/components/auth/LoginForm'
import { Building2, Calculator, Briefcase, DollarSign, Target, TrendingUp, Home, Zap } from 'lucide-react'

export function LoginPage() {
  const features = [
    {
      icon: <Calculator className="w-8 h-8 text-white" />,
      title: "Investment Strategy Analysis",
      description: "Buy & Hold, Fix & Flip, and BRRR calculations with detailed ROI projections",
      highlight: "3 Analysis Types"
    },
    {
      icon: <Briefcase className="w-8 h-8 text-white" />,
      title: "Portfolio Management",
      description: "Track multiple properties, compare performance, and optimize your investment portfolio",
      highlight: "Unlimited Properties"
    },
    {
      icon: <DollarSign className="w-8 h-8 text-white" />,
      title: "Cash Flow Calculations",
      description: "Monthly cash flow, cap rates, cash-on-cash returns, and profit margin analysis",
      highlight: "Real-time Metrics"
    },
    {
      icon: <Target className="w-8 h-8 text-white" />,
      title: "Performance Optimization",
      description: "Smart recommendations to improve returns and identify the best investment opportunities",
      highlight: "AI-Powered Insights"
    }
  ]

  return (
    <div className="min-h-screen flex">
      {/* Left Panel - Login Form */}
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 bg-white">
        <div className="w-full max-w-md space-y-8">
          <LoginForm />
        </div>
      </div>

      {/* Right Panel - Feature Showcase */}
      <div className="hidden lg:flex flex-1 bg-gradient-to-br from-primary-600 via-primary-700 to-blue-800 relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-20 w-72 h-72 bg-white rounded-full mix-blend-multiply filter blur-xl animate-pulse-slow"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-blue-300 rounded-full mix-blend-multiply filter blur-xl animate-pulse-slow animation-delay-2000"></div>
          <div className="absolute bottom-20 left-40 w-80 h-80 bg-indigo-300 rounded-full mix-blend-multiply filter blur-xl animate-pulse-slow animation-delay-4000"></div>
        </div>

        <div className="relative z-10 flex flex-col justify-center px-12">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Building2 className="w-10 h-10 text-white mr-3" />
              <div>
                <h1 className="text-2xl font-bold text-white">
                  Real Estate Analytics
                </h1>
                <p className="text-blue-100 text-sm">Investment Analysis Platform</p>
              </div>
            </div>
            
            <h2 className="text-3xl font-bold text-white mb-3">
              Build Wealth Through Strategic Real Estate Investing
            </h2>
            <p className="text-lg text-blue-100">
              Analyze investment opportunities with precise calculations for Buy & Hold, Fix & Flip, and BRRR strategies. Track portfolio performance and maximize your returns.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 gap-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-start space-x-3 p-4 rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 transition-all duration-300 animate-fade-in group"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="flex-shrink-0 p-1.5 bg-white/20 rounded-lg group-hover:scale-110 transition-transform">
                  {feature.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-1">
                    <h3 className="text-base font-semibold text-white">
                      {feature.title}
                    </h3>
                    <span className="text-xs font-medium text-blue-200 bg-white/20 px-2 py-0.5 rounded-full">
                      {feature.highlight}
                    </span>
                  </div>
                  <p className="text-blue-100 text-sm">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  )
}